import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { useUser } from './Context/UserContext';
import profileImg from "../assets/logo.png";
import ViewAllVendors from "./ViewAllVendors";
/*import "../styles/ViewAllInvoiceDeptHead.css";*/
import "../styles/ViewAllInvoiceFinanceTeam.css";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "./DashboardLayout";
import Select from "react-select";
const ViewAllInvoicesFinanceTeam = () => {
    const [invoices, setInvoices] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showCard, setShowCard] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null); // or invoice
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("history"); // or "history"
    const [comment, setComment] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [invoiceInfo, setInvoiceInfo] = useState(null);
    const [info, setinfo] = useState(null);
    const [VendorInfo, setVendorInfo] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [subTab, setSubTab] = useState("details");
    //const [isEditing, setIsEditing] = useState(false);
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [commentError, setCommentError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [supplierTypeError, setSupplierTypeError] = useState("");
    const [departmentHeadError, setDepartmentHeadError] = useState("");
    const [verifierError, setVerifierError] = useState("");
    const [emailApprovalError, setemailApprovalError] = useState("");
    const [poError, setpoError] = useState("");
    const [prError, setprError] = useState("");
    const [quotationError, setquotationError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(3);
    const { user: loggedInUser } = useUser();
    const [users, setUsers] = useState([]);
    const { user } = useUser();
    const [approverId, setApproverId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [supplierTypes, setSupplierTypes] = useState([]);
    const [departmentHeads, setDepartmentHeads] = useState([]);
    const [verifiers, setVerifiers] = useState([]);
    const [files, setFiles] = useState({});
    const [vendorFiles, setVendorFiles] = useState({});
    const [poFiles, setPoFiles] = useState({});
    const [formData, setFormData] = useState({});
    const [showPreview, setShowPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [previewTitle, setPreviewTitle] = useState("");
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [backendStatus, setBackendStatus] = useState(null);
    const [financeApproval, setFinanceApproval] = useState(null);
    const [creditDocuments, setCreditDocuments] = useState([]);
    const [agreementRefs, setAgreementRefs] = useState([]);
    const FINAL_STATUSES = [17, 13, 14, 15, 16];
    const isFinalStatus = FINAL_STATUSES.includes(backendStatus);
    const isApproved = backendStatus === 17;
    const isRejected = [13, 14, 15, 16].includes(backendStatus);
    const BASE_URL = "/";
    const [lobOptions, setLobOptions] = useState([]);
    const [projectNameOptions, setProjectNameOptions] = useState([]);
    const [taxGroupOptions, setTaxGroupOptions] = useState([]);
    const [loadingDropdowns, setLoadingDropdowns] = useState(false);
    const [dropdownError, setDropdownError] = useState("");
    const [approvedInvoices, setApprovedInvoices] = useState([]);
    const [rejectedInvoices, setRejectedInvoices] = useState([]);
    //const isApproved = String(selectedInvoice?.approvalStatus) === "1";
    //const isRejected = String(selectedInvoice?.approvalStatus) === "2";
    
    useEffect(() => {
        const id = loggedInUser?.empId || sessionStorage.getItem("userId");
        if (id) {
            setApproverId(id); // ensure number
            console.log("✅ Approver ID set:", id);
        } else {
            console.log("⏳ Waiting for user info to load...");
        }
    }, [loggedInUser]);
    const handleReviewClick = async (selected) => {
        if (!selected) return;
        setFinanceApproval(null);
        setBackendStatus(null);
        setGoodsInitialized(false);
        setSelectedInvoice(null);
        setInvoiceInfo(null);
        setVendorInfo(null);
        setSelectedVendor(null);
        setFiles({});
        setPoFiles({});
        setApprovalHistory([]);
        setHistoryData([]); 
        setCreditDocuments([]); 
        setComment("");
        setBackendStatus(null);
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");
        setSelectedInvoice({
            ...selected,
            
            approvalStatus: "",
            rejectionSendTo: "",
            comment: "",
            goodsList: []
        });

        setActiveTab("infoInvoice");
        setShowModal(true);

        try {
            // Fetch approval history
            const historyRes = await axios.get(
                `/api/invoices/approval-history/${selected.id}`
            );

            console.log("APPROVAL HISTORY:", historyRes.data);

            setHistoryData(
                Array.isArray(historyRes.data)
                    ? historyRes.data
                    : historyRes.data?.data || []
            );

            // Fetch invoice info by invoice ID
            const invoiceRes = await axios.get(
                `/api/invoices/info/${selected.id}`
            );

            const invoiceData = invoiceRes.data;

            console.log("🔴 INVOICE DATA:", invoiceData);
            console.log("🔴 USER ID:", invoiceData?.userid);
            console.log("🔴 FULL INVOICE DATA:", JSON.stringify(invoiceData, null, 2));


            setInvoiceInfo(invoiceData); // ✅ correct

            const isCredit = !!invoiceData?.creditCardNumber;
            const userId = invoiceData?.userid;

            if (isCredit) {
                if (userId) {
                    try {
                        const vendorRes = await axios.get(
                            `/api/vendordetails/vendor-by-userid/${userId}`
                        );
                        const vendorData = { ...vendorRes.data, id: vendorRes.data.vendorId };
                        setSelectedVendor(vendorData);

                        if (vendorData.vendorId) {
                            const filesRes = await axios.get(
                                `/api/vendor/files/vendor/${vendorData.vendorId}`
                            );
                            const filesMapped = {};
                            filesRes.data.forEach((file) => {
                                const key = file.docName.toUpperCase();
                                filesMapped[key] = {
                                    fileId: file.fileId,
                                    fileName: file.fileName,
                                    fileExtension: file.fileExtension,
                                    filePath: `/api/vendor/files/${file.fileId}?mode=view`,
                                };
                            });
                            setFiles(filesMapped);
                        } else {
                            setFiles({});
                        }
                    } catch (err) {
                        console.error("No vendor record found for this credit invoice:", err);
                        setSelectedVendor({
                            nameOfCompany: selected.nameOfCompany || "N/A",
                            taxGroups: null
                        });
                        setFiles({});
                    }
                } else {
                    setSelectedVendor({
                        nameOfCompany: selected.nameOfCompany || "N/A",
                        taxGroups: null
                    });
                    setFiles({});
                }
                setShowModal(true);
                return;
            }
            // Fetch vendor info using userid from invoice info
            const vendorRes = await axios.get(
                `/api/vendordetails/vendor-by-userid/${invoiceData.userid}`
            );
            const vendorData = { ...vendorRes.data, id: vendorRes.data.vendorId };
            setSelectedVendor(vendorData);
            // Fetch vendor files
            const filesRes = await axios.get(
                `/api/vendor/files/vendor/${vendorData.vendorId}`
            );
            const filesMapped = {};
            filesRes.data.forEach((file) => {
                const key = file.docName.toUpperCase();
                filesMapped[key] = {
                    fileId: file.fileId,
                    fileName: file.fileName,
                    fileExtension: file.fileExtension,
                    filePath: `/api/vendor/files/${file.fileId}?mode=view`,
                };
            });
            setFiles(filesMapped);
            setShowModal(true);
        } catch (err) {
            console.error("Error fetching invoice or vendor info:", err);
            setSelectedVendor(null);
            setFiles({});
            //alert("Unable to load vendor details.");
        }
    };
    useEffect(() => {
        fetchDropdownData();
    }, []);
    const fetchDropdownData = async () => {
        try {
            setLoadingDropdowns(true);
            setDropdownError("");
            const [lobRes, projRes, taxGroupRes] = await Promise.all([
                axios.get("/api/invoices/lob"),
                axios.get("/api/invoices/projectnames"),
                axios.get("/api/invoices/taxgroups")
            ]);
            setLobOptions(lobRes.data || []);
            setProjectNameOptions(projRes.data || []);
            setTaxGroupOptions(taxGroupRes.data || []);
            console.log("LOB:", lobRes.data);
            console.log("Projects:", projRes.data);
            console.log("TaxGroups:", taxGroupRes.data);
        } catch (error) {
            console.error("Error fetching dropdown data", error);
            setDropdownError("Failed to load dropdown data.");
        } finally {
            setLoadingDropdowns(false);
        }
    };
    const [goodsInitialized, setGoodsInitialized] = useState(false);
    // Initialize goods once
    useEffect(() => {
        if (
            !goodsInitialized &&
            (!selectedInvoice?.goodsList || selectedInvoice.goodsList.length === 0) &&
            invoiceInfo?.grnItems?.length > 0 &&
            taxGroupOptions?.length > 0
        ) {
            const initializedGoods = invoiceInfo.grnItems.map((item, idx) => {
                const matchingGroup =
                    taxGroupOptions.find(
                        (group) =>
                            group.taxGroup?.toUpperCase() ===
                            item.taxGroupCode?.toUpperCase()
                    ) ||
                    taxGroupOptions.find(
                        (group) =>
                            group.taxGroup?.toUpperCase() ===
                            selectedVendor?.taxGroups?.toUpperCase()
                    );
                const authorities = matchingGroup?.authorities || [];
                const getRate = (type) => {
                    const authority = authorities.find((auth) =>
                        auth.taxAuthority?.toUpperCase().includes(type.toUpperCase())
                    );
                    return authority?.taxRates?.[0] || 0;
                };
                return {
                    id: item.id,
                    description: item.description || "",
                    invoiceValue: item.invoiceValue || 0,
                    cgst: getRate("CGST"),
                    sgst: getRate("SGST"),
                    igst: getRate("IGST"),
                    tds: getRate("TDS"),
                    totalValue: item.totalValue || 0,
                    lob: item.lob || "",
                    projectName: item.projectName || "",
                    MSPE: item.mspe,
                    taxGroupCode: matchingGroup?.taxGroup || "",
                };
            });
            setSelectedInvoice((prev) => ({
                ...prev,
                goodsList: initializedGoods
            }));
            setGoodsInitialized(true);
        }
    }, [invoiceInfo, taxGroupOptions, selectedVendor, goodsInitialized, selectedInvoice]);
    // Handle changes in goods row
    const calculateGoodsTotal = (item) => {
        const invoiceValue = Number(item.invoiceValue) || 0;
        const cgst = Number(item.cgst) || 0;
        const sgst = Number(item.sgst) || 0;
        const igst = Number(item.igst) || 0;
        const tds = Number(item.tds) || 0;

        // CGST/SGST/IGST are additive tax %, TDS is a deduction %
        const taxAmount = invoiceValue * (cgst + sgst + igst) / 100;
        const tdsAmount = invoiceValue * tds / 100;

        return invoiceValue + taxAmount;
    };

    const handleGoodsChange = (index, key, value) => {
        setSelectedInvoice((prev) => {
            const updatedGoodsList = [...(prev.goodsList || [])];
            const item = { ...updatedGoodsList[index] };
            if (key === "taxGroupCode") {
                item.taxGroupCode = value;
                const selectedGroup = taxGroupOptions.find(
                    (g) =>
                        g.taxGroup?.toUpperCase() === value?.toUpperCase()
                );
                const authorities = selectedGroup?.authorities || [];
                const getFirstRate = (type) => {
                    const authority = authorities.find((auth) =>
                        auth.taxAuthority?.toUpperCase().includes(type.toUpperCase())
                    );
                    // 🚀 DO NOT FILTER ZERO
                    return authority?.taxRates?.[0] || 0;
                };
                item.cgst = getFirstRate("CGST");
                item.sgst = getFirstRate("SGST");
                item.igst = getFirstRate("IGST");
                item.tds = getFirstRate("TDS");
            } else {
                item[key] = value;
            }

            // Recalculate total whenever invoiceValue or any tax % changes
            if (["invoiceValue", "cgst", "sgst", "igst", "tds", "taxGroupCode"].includes(key)) {
                item.totalValue = calculateGoodsTotal(item);
            }

            updatedGoodsList[index] = item;
            return { ...prev, goodsList: updatedGoodsList };
        });
    };
    const [updatingGoods, setUpdatingGoods] = useState(false);

    const handleUpdateAllGoodsRows = async () => {
        const rowsWithId = (selectedInvoice?.goodsList || []).filter((item) => item?.id);

        if (rowsWithId.length === 0) {
            alert("No rows to update.");
            return;
        }

        setUpdatingGoods(true);

        try {
            await Promise.all(
                rowsWithId.map((item) => {
                    const payload = {
                        Id: Number(item.id),
                        Description: item.description,
                        InvoiceValue: Number(item.invoiceValue) || 0,
                        CGST: item.cgst !== "" ? Number(item.cgst) : null,
                        SGST: item.sgst !== "" ? Number(item.sgst) : null,
                        IGST: item.igst !== "" ? Number(item.igst) : null,
                        TDS: item.tds !== "" ? Number(item.tds) : null,
                        TotalValue: Number(item.totalValue) || 0,
                        LOB: item.lob,
                        ProjectName: item.projectName,
                        MSPE: item.mspe,
                        TaxGroupCode: item.taxGroupCode
                    };

                    return axios.put(`/api/invoice/goods-item/${item.id}`, payload);
                })
            );

            alert("All rows updated successfully.");
        } catch (error) {
            console.error("Error updating goods rows:", error);
            alert("Failed to update one or more rows.");
        } finally {
            setUpdatingGoods(false);
        }
    };
    useEffect(() => {
        if (!invoiceInfo?.userid) return;

        const isCredit = !!invoiceInfo?.creditCardNumber;
        if (isCredit) {
            return;
        }

        axios
            .get(`/api/vendordetails/vendor-by-userid/${invoiceInfo.userid}`)
            .then((res) => {
                console.log("Vendor Info:", res.data);
                setVendorInfo(res.data);
                setSelectedVendor(res.data);
            })
            .catch((err) => {
                console.error("Error fetching vendor info", err);
                setVendorInfo(null);
            });
    }, [invoiceInfo]);

    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key !== "Escape" || !showModal) return;

            // If preview is open, ESC closes preview first
            if (showPreview) {
                setShowPreview(false);
                return;
            }

            // Go backwards through review tabs
            if (activeTab === "details") {
                setActiveTab("infoInvoice");
                return;
            }

            if (activeTab === "infoInvoice") {
                setActiveTab("history");
                return;
            }

            if (activeTab === "history") {
                setActiveTab("info");
                return;
            }

            // If already at the first tab, close the Review window
            if (activeTab === "info") {
                setShowModal(false);
            }
        };

        document.addEventListener("keydown", handleEscKey);

        return () => {
            document.removeEventListener("keydown", handleEscKey);
        };
    }, [showModal, showPreview, activeTab]);

    useEffect(() => {
        if (!selectedVendor?.vendorId) return;
        axios
            .get(`/api/vendor/files/vendor/${selectedVendor.vendorId}`)
            .then((res) => {
                const filesMapped = {};
                res.data.forEach((file) => {
                    const key = file.docName.toUpperCase(); // PAN, GST, MSME, CHEQUE
                    filesMapped[key] = {
                        fileId: file.fileId,
                        fileName: file.fileName,
                        fileExtension: file.fileExtension,
                        filePath: `/api/vendor/files/${file.fileId}?mode=view`, // preview link
                    };
                });
                setFiles(filesMapped);
            })
            .catch((err) => {
                console.error("Error fetching vendor files:", err);
                setFiles({});
            });
    }, [selectedVendor]);
    useEffect(() => {
        const vid = selectedVendor?.vendorId;
        if (!vid) {
            setAgreementRefs([]);
            return;
        }
        axios
            .get(`/api/vendoragreement/by-vendor/${vid}`)
            .then((res) => setAgreementRefs(Array.isArray(res.data) ? res.data : []))
            .catch((err) => {
                console.error("Error fetching agreement references:", err);
                setAgreementRefs([]);
            });
    }, [selectedVendor?.vendorId]);
    const handleFileChange = (e) => {
        const { name, files: selectedFiles } = e.target;
        if (selectedFiles && selectedFiles.length > 0) {
            setFiles((prev) => ({
                ...prev,
                [name]: selectedFiles[0]
            }));
        }
    };
    const statusMapping = {
        Pending: 3,
        Rejected: 2,
        Approved: 1
    };
    const mapBackendStatusToUI = (status) => {
        if (status === 17) return "1";  // Approved
        if (status === 13 || status === 14 || status === 15 || status === 16) return "2"; // Rejected
        return "3"; // Pending
    };
    const mapInvoiceSendTo = (status) => {
        if (status === 31) return "Verifier";
        if (status === 13) return "DEPT HEAD";
        if (status === 14) return "PO";
        if (status === 15) return "Security";
        if (status === 16) return "Vendor";
        return "";
    };
    useEffect(() => {
        const fetchInvoices = async () => {
            setLoading(true);
            try {
                const res = await axios.get(
                    "/api/invoices/finance-list",
                    {
                        params: {
                            statusId: selectedStatus || 3,
                            search: searchTerm || ""
                        }
                    }
                );
                console.log("Finance Invoices:", res.data);
                setInvoices(res.data || []);
            } catch (err) {
                console.error("Error fetching finance invoices:", err);
                setInvoices([]);
            } finally {
                setLoading(false);
            }
        };
        fetchInvoices();
    }, [selectedStatus, searchTerm]);
    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };
    const handleSort = (column) => {
        const sortedInvoices = [...invoices].sort((a, b) => {
            let valueA, valueB;
            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }
            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });
        setInvoices(sortedInvoices);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };
    const invoicesPerPage = 6;
    const [historyData, setHistoryData] = useState([]);
    // useEffect(() => {
    //     if (!selectedInvoice?.id) return;
    //     console.log("Invoice ID being sent:", selectedInvoice.id);
    //     axios
    //         .get(`/api/invoices/approval-history/${selectedInvoice.id}`)
    //         .then((res) => {
    //             console.log("APPROVAL HISTORY:", res.data);
    //             setHistoryData(res.data);
    //         })
    //         .catch((err) => {
    //             console.error("Error fetching approval history:", err);
    //             setHistoryData([]);
    //         });
    // }, [activeTab, selectedInvoice]);
    useEffect(() => {
        if (activeTab !== "infoInvoice") return;
        const invoiceId = selectedInvoice?.id || selectedInvoice?.ID;
        if (!invoiceId) return;
        axios
            .get(`/api/invoices/info/${invoiceId}`)
            .then((res) => {
                console.log("Invoice Info:", res.data);
                setInvoiceInfo(res.data); // <-- use res.data directly
            })
            .catch((err) => {
                console.error("Error fetching invoice info:", err);
            });
    }, [activeTab, selectedInvoice]);
    // Pagination
    const totalPages = Math.ceil(invoices.length / invoicesPerPage);
    const startIndex = (currentPage - 1) * invoicesPerPage;
    const currentInvoices = invoices.slice(startIndex, startIndex + invoicesPerPage);
    const handlePageChange = (action) => {
        if (action === "first") setCurrentPage(1);
        else if (action === "prev" && currentPage > 1) setCurrentPage(prev => prev - 1);
        else if (action === "next" && currentPage < totalPages) setCurrentPage(prev => prev + 1);
        else if (action === "last") setCurrentPage(totalPages);
    };
    useEffect(() => {
        axios
            .get("/api/supplier/supplier-types")
            .then((res) => {
                setSupplierTypes(res.data);
            })
            .catch((err) => {
                console.error("Error fetching supplier types:", err);
                setSupplierTypes([]);
            });
    }, []);
    useEffect(() => {
        if (!selectedInvoice?.id) return;
        console.log("📡 Calling API with recordId:", selectedInvoice.id);
        axios
            .get(`/api/supplier/invoice-approval-data/${selectedInvoice.id}`)
            /*.get(`/api/supplier/invoice-approval-data/39`)*/
            .then((res) => {
                const data = res.data;
                console.log("✅ API ResponseDEPT,VERIFIER:", data);
                // 1️⃣ First set dropdown lists
                setDepartmentHeads(data.departmentHeads || []);
                setVerifiers(data.verifiers || []);
                // 2️⃣ Then update selectedInvoice AFTER options exist
                setTimeout(() => {
                    setSelectedInvoice((prev) => ({
                        ...prev,
                        supplierType: data.supplierType ? String(data.supplierType) : "",
                        departmentHead: data.departmentHeadId || "",
                        verifier: data.verifierId || ""
                    }));
                }, 0);
            })
            .catch((err) => {
                console.error("❌ Error loading approval data:", err);
            });
    }, [selectedInvoice?.id]);
    const handleSaveStatus = async () => {
        let isValid = true;
        // ✅ Approval Status validation
        if (
            String(selectedInvoice?.approvalStatus) !== "1" &&
            String(selectedInvoice?.approvalStatus) !== "2"
        ) {
            setApprovalStatusError("Approval status is required");
            isValid = false;
        }
        // ✅ Comments validation
        if (!selectedInvoice?.comment || selectedInvoice.comment.trim() === "") {
            setCommentError("Comments are required");
            isValid = false;
        }
        // ✅ Rejection Send To validation (only if rejected)
        if (
            selectedInvoice?.approvalStatus === "2" &&
            !selectedInvoice?.rejectionSendTo
        ) {
            setRejectionSendToError("Please select where to send");
            isValid = false;
        }
        if (!isValid) return;
        try {
            const payload = {
                InvoiceId: selectedInvoice.id,
                InvoiceNo: selectedInvoice.invoiceNo,
                ApprovalStatus: Number(selectedInvoice.approvalStatus),
                FinanceID: loggedInUser.empId,
                Comments: selectedInvoice.comment,
                RejectionSendTo:
                    selectedInvoice.approvalStatus === "2"
                        ? Number(selectedInvoice.rejectionSendTo)
                        : null,
                // ✅ Goods List
                GoodsList: selectedInvoice.goodsList.map(item => ({
                    Id: item.id ? Number(item.id) : 0,
                    Description: item.description,
                    InvoiceValue: item.invoiceValue,
                    //CGST: item.cgst,
                    //SGST: item.sgst,
                    //IGST: item.igst,
                    //TDS: item.tds,
                    CGST: item.cgst ? Number(item.cgst) : null,
                    SGST: item.sgst ? Number(item.sgst) : null,
                    IGST: item.igst ? Number(item.igst) : null,
                    TDS: item.tds ? Number(item.tds) : null,
                    TotalValue: item.totalValue,
                    LOB: item.lob,
                    ProjectName: item.projectName,
                    MSPE: item.mspe,
                    TaxGroupCode: item.taxGroupCode
                }))
            };
            const response = await axios.post(
                "/api/invoice/finance-approval",
                payload
            );
            console.log("FINAL PAYLOAD:", payload);
            if (response.status === 200) {
                alert(response.data.message || "Finance approval saved successfully.");
                // ✅ REMOVE from pending
                setInvoices(prev =>
                    prev.filter(inv => inv.id !== selectedInvoice.id)
                );
                // ✅ OPTIONAL (for future use / tabs)
                let updatedInvoice = { ...selectedInvoice };
                if (selectedInvoice.approvalStatus === "1") {
                    updatedInvoice.approvalStatus =
                        "Approved by Finance, Pending from CFO";
                    updatedInvoice.backendStatus = 11; // adjust if needed
                    // OPTIONAL
                    // setApprovedInvoices(prev => [...prev, updatedInvoice]);
                } else if (selectedInvoice.approvalStatus === "2") {
                    const sendTo = Number(selectedInvoice.rejectionSendTo);
                    if (sendTo === 2)
                        updatedInvoice.approvalStatus = "Invoice Rejected by Finance, Pending from Dept Head";
                    else if (sendTo === 3)
                        updatedInvoice.approvalStatus = "Invoice Rejected by Finance, Pending from PO";
                    else if (sendTo === 4)
                        updatedInvoice.approvalStatus = "Invoice Rejected by Finance, Pending from Security";
                    else if (sendTo === 5)
                        updatedInvoice.approvalStatus = "Invoice Rejected by Finance, Pending from Vendor";
                    else if (sendTo === 6)
                        updatedInvoice.approvalStatus = "Invoice Rejected by Finance, Pending from Verifier";
                    updatedInvoice.backendStatus = 6;
                    // OPTIONAL
                    // setRejectedInvoices(prev => [...prev, updatedInvoice]);
                }
                setShowModal(false);
                setIsEditing(false);
            }
        } catch (error) {
            console.error("Error saving finance approval:", error);
            alert("Something went wrong while saving.");
        }
    };
    const mapSendToToDropdownValue = (sentBackTo) => {
        console.log("🔄 Mapping SentBackTo:", sentBackTo);
        if (sentBackTo === "PO") return "3";
        if (sentBackTo === "Security") return "4";
        if (sentBackTo === "Vendor") return "5";
        if (sentBackTo === "Verifier") return "6";
        return "";
    };
    useEffect(() => {
        if (!showModal || !selectedInvoice?.id || !loggedInUser?.empId) return;

        const loadFinanceData = async () => {
            try {
                setFinanceApproval(null);
                setBackendStatus(null);
                setCreditDocuments([]);

                const res = await axios.get(
                    `/api/invoice/finance-invoice-full/${selectedInvoice.id}`,
                    {
                        params: {
                            approverId: loggedInUser.empId
                        }
                    }
                );

                console.log("✅ Finance Full Data:", res.data);

                const invoice = res.data.invoice || {};
                const goods = res.data.goodsList || [];
                const approval = res.data.approval;

                setCreditDocuments(res.data.creditDocuments || []);

                let updatedInvoice = {
                    ...invoice,
                    goodsList: goods
                };

                if (approval) {
                    setFinanceApproval(approval);
                    setBackendStatus(approval.statusId);

                    updatedInvoice = {
                        ...updatedInvoice,

                        approvalStatus:
                            Number(approval.statusId) === 17
                                ? "1"
                                : [13, 14, 15, 16].includes(Number(approval.statusId))
                                    ? "2"
                                    : "",

                        rejectionSendTo:
                            [13, 14, 15, 16].includes(Number(approval.statusId))
                                ? mapSendToToDropdownValue(approval.sentBackTo)
                                : "",

                        comment: approval.comments || ""
                    };
                } else {
                    updatedInvoice = {
                        ...updatedInvoice,
                        approvalStatus: "",
                        rejectionSendTo: "",
                        comment: ""
                    };
                }

                setSelectedInvoice(prev => ({
                    ...prev,
                    ...updatedInvoice
                }));

            } catch (err) {
                console.error("❌ Finance API Error:", err);
            }
        };

        loadFinanceData();

    }, [showModal, selectedInvoice?.id, loggedInUser?.empId]);

    const groupCreditDocsByRow = (docs) => {
        const grouped = {};
        (docs || []).forEach((path) => {
            const fileName = path?.split("/").pop() || "";
            const match = fileName.match(/_ROW(\d+)_/i);
            if (match) {
                const rowIndex = parseInt(match[1], 10);
                if (!grouped[rowIndex]) grouped[rowIndex] = [];
                grouped[rowIndex].push(path);
            }
        });
        return grouped;
    };
    const renderDocumentFile = (fileData, fileName, title) => {
        if (!fileData || typeof fileData !== "string" || fileData.trim() === "") {
            return <span style={{ color: "gray" }}>No file uploaded</span>;
        }
        let fileUrl = "";
        let cleanPath = fileData.trim();
        // 🔥 Fix backslashes (Windows paths)
        cleanPath = cleanPath.replace(/\\/g, "/");
        // 🔥 Strip ASP.NET virtual-path tilde prefix (~/ or ~)
        cleanPath = cleanPath.replace(/^~\/?/, "");
        // 🔥 Fix wrong folder case (VERY IMPORTANT)
        cleanPath = cleanPath.replace(/^invoicecopy/i, "InvoiceCopy");
        // ✅ Valid full URL
        if (cleanPath.startsWith("http")) {
            // ❌ Fix wrong host like http://invoicecopy/...
            if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
                fileUrl = cleanPath;
            } else {
                fileUrl = `${BASE_URL}/${cleanPath.replace(/^\/+/, "")}`;
            }
        }
        // ✅ Base64 PDF
        else if (cleanPath.startsWith("JVBER")) {
            fileUrl = `data:application/pdf;base64,${cleanPath}`;
        }
        // ✅ Relative path
        else {
            fileUrl = `${BASE_URL.replace(/\/$/, "")}/${cleanPath.replace(/^\/+/, "")}`;
        }
        console.log("Final File URL:", fileUrl); // 🔥 DEBUG
        const displayName =
            fileName ||
            (cleanPath.includes("/") ? cleanPath.split("/").pop() : "Document");
        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                {/* File Name */}
                <span style={{ color: "#0a4275", fontWeight: "500" }}>
                    {displayName}
                </span>
                {/* Buttons */}
                <div style={{ display: "flex", gap: "8px", marginTop: "5px" }}>
                    <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={() => {
                            console.log("Clicked View", fileUrl);
                            setPreviewUrl(fileUrl);
                            setPreviewTitle(title);
                            setShowPreview(true);
                        }}
                    >
                        View
                    </Button>
                    
                </div>
            </div>
        );
    };
    const viewTimesheet = async () => {
        const name = invoiceInfo?.fileNameTimeSheet || "timesheet";
        const invoiceId = selectedInvoice?.id || selectedInvoice?.ID;

        // PDF / image: show in the preview window (unchanged)
        if (/\.(pdf|png|jpe?g|gif|webp)$/i.test(name)) {
            const path = (invoiceInfo?.timeSheetFilePath || "")
                .replace(/\\/g, "/").replace(/^~\/?/, "").replace(/^\/+/, "");
            setPreviewUrl(`${window.location.origin}/${path}`);
            setPreviewTitle("TimeSheet Preview");
            setShowPreview(true);
            return;
        }

        // Excel, csv, msg, zip: download through the backend endpoint
        try {
            const res = await axios.get(
                `/api/invoices/timesheet-download/${invoiceId}`,
                { responseType: "blob" }
            );

            const blobUrl = window.URL.createObjectURL(
                new Blob([res.data], { type: "application/octet-stream" })
            );
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error("Timesheet download failed:", err);
            alert("Unable to download the timesheet.");
        }
    };
    const viewTimesheetMessage = async () => {
        const invoiceId = selectedInvoice?.id || selectedInvoice?.ID;

        try {
            const res = await axios.get(
                `/api/invoices/timesheet-message/${invoiceId}`
            );

            alert(
                `Subject: ${res.data.subject}\n\n` +
                `From: ${res.data.from}\n\n` +
                `Message:\n${res.data.bodyText}`
            );
        } catch (err) {
            console.error("Error reading timesheet message:", err);
            alert("Unable to read the timesheet message.");
        }
    };
    return (
        <DashboardLayout>
            

            <div className="invoice-container">
                <h2 className="invoice-title" style={{ marginTop: 0, marginBottom: '15px', color: '#0a4275', paddingTop: '10px' }}>
                    Invoice Approval Details
                </h2>
                <div className="vendor-toolbar">
                    {/* Search Box */}
                    <div className="vendor-toolbar-search">
                        <div className="vendor-search-box invoice-search-box">
                            <span className="vendor-search-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="11" cy="11" r="8" />
                                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                </svg>
                            </span>
                            <Input
                                type="text"
                                placeholder="Search by Company Name..."
                                value={searchTerm}
                                onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                                aria-label="Search by company name"
                                className="vendor-search-input"
                            />
                            {searchTerm && (
                                <button
                                    type="button"
                                    className="vendor-search-clear"
                                    aria-label="Clear search"
                                    onClick={() => { setSearchTerm(""); setCurrentPage(1); }}
                                >
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                    </svg>
                                </button>
                            )}
                        </div>
                    </div>
                    {/* Status Dropdown */}
                    <div className="vendor-status-filter">
                        <label className="vendor-status-label">Approved Status:</label>
                        <Input
                            type="select"
                            className="vendor-status-select"
                            value={selectedStatus}
                            onChange={(e) => { setSelectedStatus(Number(e.target.value)); setCurrentPage(1); }}
                        >
                            <option value={statusMapping.Pending}>⏳ Pending</option>
                            <option value={statusMapping.Approved}>✔️ Approved</option>
                            <option value={statusMapping.Rejected}>❌ Rejected</option>
                        </Input>
                    </div>
                </div>
                {/* Main Invoice Table */}
                <table className="invoice-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Company Name</th>
                            <th>Invoice Type</th>
                            <th>Supplier Type</th>
                            <th>Invoice No</th>
                            <th>Total Value</th>
                            <th>DC Number</th>
                            <th>Create Date</th>
                            <th onClick={() => handleSort("approvalStatus")} style={{ cursor: "pointer" }}>
                                Approval Status {sortBy === "approvalStatus" ? (sortOrder === "asc" ? "▲" : "▼") : "⇅"}
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentInvoices.map((invoice, index) => (
                            <tr key={index}>
                                <td>{startIndex + index + 1}</td>
                                <td>
                                    {invoice.msmeNo && invoice.msmeNo !== "N/A" && (
                                        <div className="msme-badge-wrap">
                                            <span className="msme-badge">MSME</span>
                                        </div>
                                    )}
                                    <div className="company-name-text">{invoice.nameOfCompany}</div>
                                </td>
                                <td>{invoice.invoiceType}</td>
                                <td>{invoice.supplierType}</td>
                                <td>{invoice.invoiceNo}</td>
                                <td>{(invoice.totalValue ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                <td>{invoice.dcnumber}</td>
                                <td>{invoice.createdDate}</td>
                                <td>{invoice.approvalStatus}</td>
                                <td>
                                    <button className="review-btn" onClick={() => handleReviewClick(invoice)}>Review</button>                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {/* Pagination */}
                <div className="pagination">
                    <button onClick={() => handlePageChange("first")} disabled={currentPage === 1}>First</button>
                    <button onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>Previous</button>
                    <span className="page-info">Page {currentPage} of {totalPages}</span>
                    <button onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>Next</button>
                    <button onClick={() => handlePageChange("last")} disabled={currentPage === totalPages}>Last</button>
                </div>
            </div>
            {/* ======================================================= */}
            {/* FULLSCREEN DIV — for Invoice Info & Approve/Reject tabs  */}
            {/* ======================================================= */}
            {showModal && (activeTab === "details" || activeTab === "infoInvoice") && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 1055,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <div style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        width: "95%",
                        maxWidth: "1200px",
                        maxHeight: "90vh",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        boxShadow: "0 10px 40px rgba(0,0,0,0.3)"
                    }}>
                        {/* Header */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "18px 24px",
                            flexShrink: 0,
                            background: "linear-gradient(135deg, #1f4e78, #2a5d8f)"
                        }}>
                            <h5 style={{ margin: 0, fontWeight: 600, color: "white", fontSize: "20px" }}>Invoice Details</h5>
                            <button
                                onClick={() => setShowModal(false)}
                                style={{
                                    background: "rgba(255,255,255,0.2)",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "white",
                                    lineHeight: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                &times;
                            </button>
                        </div>
                    {/* Tabs */}
                    <div style={{
                        display: "flex",
                        gap: "5px",
                        padding: "10px 24px 0",
                        borderBottom: "2px solid #1f4e78",
                        flexShrink: 0,
                        backgroundColor: "white"
                    }}>
                        {[
                            { key: "info", label: "Vendor Info" },
                            { key: "history", label: "Invoice Approval History" },
                            { key: "infoInvoice", label: "Invoice Info" },
                            { key: "details", label: "Approve/Reject" }
                        ].map((tab) => (
                            <span
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                style={{
                                    padding: "8px 16px",
                                    cursor: "pointer",
                                    borderRadius: "8px 8px 0 0",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    backgroundColor: activeTab === tab.key ? "#1f4e78" : "#f1f3f5",
                                    color: activeTab === tab.key ? "white" : "#333",
                                    userSelect: "none"
                                }}
                            >
                                {tab.label}
                            </span>
                        ))}
                    </div>
                    {/* Scrollable Body */}
                    <div style={{
                        flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        padding: "20px 30px",
                        width: "100%",
                        boxSizing: "border-box"
                    }}>
                        {/* =================== APPROVE/REJECT TAB =================== */}
                        {activeTab === "details" && (
                            <>
                                <Table bordered className="info-table1">
                                    <tbody>
                                        {/* Company */}
                                        <tr>
                                            <th><strong>Name of Company:</strong></th>
                                            <td>{selectedVendor?.nameOfCompany || "N/A"}</td>
                                            <th><strong>Tax Group:</strong></th>
                                            <td>{selectedVendor?.taxGroups || "N/A"}</td>
                                        </tr>
                                        {/* Approval Status + Comments */}
                                        <tr>
                                            <th>
                                                <strong>Approval Status:</strong>
                                                <span className="required-field">*</span>
                                            </th>
                                            <td>
                                                <Input
                                                    type="select"
                                                    value={selectedInvoice?.approvalStatus ?? ""}
                                                    disabled={isFinalStatus}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setSelectedInvoice(prev => ({ ...(prev || {}), approvalStatus: value })); // ✅ was "field"
                                                        setApprovalStatusError("");
                                                    }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="1">Approved</option>
                                                    <option value="2">Rejected</option>
                                                </Input>
                                                {!isFinalStatus && approvalStatusError && (
                                                    <div className="text-danger">{approvalStatusError}</div>
                                                )}
                                            </td>
                                            <th>
                                                <strong>Comments:</strong>
                                                <span className="required-field">*</span>
                                            </th>
                                            <td>
                                                <Input
                                                    type="textarea"
                                                    value={selectedInvoice?.comment ?? ""}
                                                    disabled={isFinalStatus}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setSelectedInvoice(prev => ({ ...(prev || {}), comment: value })); // ✅ was "field"
                                                        setCommentError("");
                                                    }}
                                                />
                                                {!isFinalStatus && commentError && (
                                                    <div className="text-danger">{commentError}</div>
                                                )}
                                            </td>
                                        </tr>
                                        {/* Rejection Send To */}
                                        <tr>
                                            <th>
                                                <strong>Rejection Send To:</strong>
                                                <span className="required-field">*</span>
                                            </th>
                                            <td>
                                                <Input
                                                    type="select"
                                                    value={selectedInvoice?.rejectionSendTo || ""}
                                                    disabled={isFinalStatus || String(selectedInvoice?.approvalStatus) !== "2"}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setSelectedInvoice(prev => ({ ...(prev || {}), rejectionSendTo: value })); // ✅ already correct
                                                        setRejectionSendToError("");
                                                    }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="2">Dept Head</option>
                                                    <option value="3">PO</option>
                                                    <option value="4">Security</option>
                                                    <option value="5">Vendor</option>
                                                    <option value="6">Verifier</option>
                                                </Input>
                                                {rejectionSendToError && selectedInvoice?.approvalStatus === "2" && (
                                                    <div className="text-danger">{rejectionSendToError}</div>
                                                )}
                                            </td>
                                            <th></th>
                                            <td></td>
                                        </tr>
                                        {/* Goods Table */}
                                        <tr>
                                            <td colSpan={4}>
                                                <div className="text-center mt-3 mb-2">
                                                    <strong>The Following Goods have been Received</strong>
                                                </div>
                                                <div style={{ width: "100%", overflowX: "hidden" }}>
                                                        <table className="table table-bordered align-middle table-hover goods-table mt-2"
                                                            style={{ width: "100%", tableLayout: "fixed", fontSize: "11px" }}>
                                                            <thead className="table-header11 text-center">
                                                                <tr>
                                                                    <th style={{ width: "30px", padding: "4px 2px", fontSize: "10px" }}>Sr</th>
                                                                    <th style={{ width: "110px", padding: "4px 2px", fontSize: "10px" }}>Description</th>
                                                                    <th style={{ width: "70px", padding: "4px 2px", fontSize: "10px" }}>Inv. Value</th>
                                                                    <th style={{ width: "85px", padding: "4px 2px", fontSize: "10px" }}>Tax Grp</th>
                                                                    <th style={{ width: "60px", padding: "4px 2px", fontSize: "10px" }}>CGST</th>
                                                                    <th style={{ width: "60px", padding: "4px 2px", fontSize: "10px" }}>SGST</th>
                                                                    <th style={{ width: "60px", padding: "4px 2px", fontSize: "10px" }}>IGST</th>
                                                                    <th style={{ width: "60px", padding: "4px 2px", fontSize: "10px" }}>TDS</th>
                                                                    <th style={{ width: "70px", padding: "4px 2px", fontSize: "10px" }}>Total</th>
                                                                    <th style={{ width: "95px", padding: "4px 2px", fontSize: "10px" }}>LOB</th>
                                                                    <th style={{ width: "95px", padding: "4px 2px", fontSize: "10px" }}>Project</th>
                                                                    <th style={{ width: "55px", padding: "4px 2px", fontSize: "10px" }}>MS/PS</th>
                                                                   
                                                                
                                                                </tr>
                                                            </thead>
                                                        <tbody>
                                                            {(selectedInvoice?.goodsList || []).map((item, index) => {
                                                                const selectedGroup = taxGroupOptions.find(
                                                                    (group) => group.taxGroup?.toUpperCase() === item.taxGroupCode?.toUpperCase()
                                                                );
                                                                const authorities = selectedGroup?.authorities || [];
                                                                let cgstOptions = [];
                                                                let sgstOptions = [];
                                                                let igstOptions = [];
                                                                let tdsOptions = [];
                                                                authorities.forEach((auth) => {
                                                                    const authorityName = auth.taxAuthority?.toUpperCase() || "";
                                                                    const formattedRates = (auth.taxRates || [])
                                                                        .filter(rate => rate !== 0 && rate !== null && rate !== undefined)
                                                                        .map((rate, i) => ({
                                                                            itemRateKey: `itemRate${i + 1}`,
                                                                            label: `itemRate${i + 1} : ${Math.abs(rate)}%`,
                                                                            value: rate.toString()
                                                                        }));
                                                                    if (authorityName.includes("CGST")) cgstOptions.push(...formattedRates);
                                                                    if (authorityName.includes("SGST")) sgstOptions.push(...formattedRates);
                                                                    if (authorityName.includes("IGST")) igstOptions.push(...formattedRates);
                                                                    if (authorityName.includes("TDS")) tdsOptions.push(...formattedRates);
                                                                });
                                                                return (
                                                                    <tr key={index}>
                                                                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                                                                        <td>{item.description || "N/A"}</td>
                                                                        <td>
                                                                            <Input
                                                                                type="text"
                                                                                value={item.invoiceValue || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "invoiceValue", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "14Spx", height: "28px" }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <select
                                                                                className="form-select"
                                                                                value={item.taxGroupCode || selectedVendor?.taxGroups || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "taxGroupCode", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "14px", height: "28px" }}
                                                                            >
                                                                                <option value="">--Select--</option>
                                                                                {taxGroupOptions.map((group) => (
                                                                                    <option key={group.taxGroup} value={group.taxGroup}>
                                                                                        {group.taxGroup} - {group.description}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        {/* CGST */}
                                                                        <td>
                                                                            <select className="form-select" value={item.cgst?.toString() || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "cgst", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "14px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {cgstOptions.map((opt) => (
                                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        {/* SGST */}
                                                                        <td>
                                                                            <select className="form-select" value={item.sgst?.toString() || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "sgst", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "14px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {sgstOptions.map((opt) => (
                                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        {/* IGST */}
                                                                        <td>
                                                                            <select className="form-select" value={item.igst?.toString() || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "igst", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "14px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {igstOptions.map((opt) => (
                                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        {/* TDS */}
                                                                        <td>
                                                                            <select className="form-select" value={item.tds?.toString() || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "tds", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "14px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {tdsOptions.map((opt) => (
                                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        {/* Total Value */}
                                                                        <td>
                                                                            <Input type="text" value={item.totalValue || ""} readOnly
                                                                                style={{ width: "100%", fontSize: "14px", height: "28px" }} />
                                                                        </td>
                                                                        {/* LOB */}
                                                                        <td>
                                                                            <Input
                                                                                type="text"
                                                                                placeholder="Search LOB..."
                                                                                value={item.lobSearch || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "lobSearch", e.target.value)}
                                                                                style={{ marginBottom: "4px", fontSize: "14px", height: "28px" }}
                                                                            />
                                                                            <select className="form-select" value={item.lob || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "lob", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "14px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {lobOptions
                                                                                    .filter((lob) => lob.toLowerCase().includes((item.lobSearch || "").toLowerCase()))
                                                                                    .map((lob, i) => (
                                                                                        <option key={i} value={lob}>{lob}</option>
                                                                                    ))}
                                                                            </select>
                                                                        </td>
                                                                        {/* Project Name */}
                                                                        <td>
                                                                            <Input
                                                                                type="text"
                                                                                placeholder="Search Project..."
                                                                                value={item.projectSearch || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "projectSearch", e.target.value)}
                                                                                style={{ marginBottom: "4px", fontSize: "14px", height: "28px" }}
                                                                            />
                                                                            <select className="form-select" value={item.projectName || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "projectName", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "14px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {projectNameOptions
                                                                                    .filter((proj) =>
                                                                                        (proj?.value || proj?.toString() || "")
                                                                                            .toLowerCase()
                                                                                            .includes((item.projectSearch || "").toLowerCase())
                                                                                    )
                                                                                    .map((proj, i) => (
                                                                                        <option key={i} value={proj.value || proj}>{proj.value || proj}</option>
                                                                                    ))}
                                                                            </select>
                                                                        </td>
                                                                        {/* MS/PS */}
                                                                        <td>
                                                                            <select className="form-select" value={item.mspe || ""}
                                                                                disabled={isFinalStatus}
                                                                                onChange={(e) => handleGoodsChange(index, "mspe", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "14px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                <option value="MS">MS</option>
                                                                                <option value="PS">PS</option>
                                                                                <option value="NA">NA</option>
                                                                            </select>
                                                                        </td>
                                                                        
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                    </div>
                                                {!isFinalStatus && (
                                                    <div className="text-center mt-2">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-sm px-4"
                                                            disabled={updatingGoods}
                                                            onClick={handleUpdateAllGoodsRows}
                                                        >
                                                            {updatingGoods ? "Updating..." : "Update"}
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </>
                        )}
                        {/* =================== INVOICE INFO TAB =================== */}
                        {activeTab === "infoInvoice" && invoiceInfo && (
                            <>
                                <Table bordered className="info-table1">
                                    <tbody>
                                        <tr>
                                            <th><strong>Invoice Type:</strong></th>
                                            <td>{invoiceInfo.invoiceType || "N/A"}</td>
                                            <th><strong>Supplier Type:</strong></th>
                                            <td>
                                                {invoiceInfo.invoiceSupplierType === 1
                                                    ? "Supply of Goods"
                                                    : invoiceInfo.invoiceSupplierType === 2
                                                        ? "Supply of Service"
                                                        : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th><strong>Invoice Document:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.invoiceFilePath, invoiceInfo.fileName, "Invoice Document Preview")}</td>
                                            <th><strong>Invoice Date:</strong></th>
                                            <td>{invoiceInfo.invoiceDate ? new Date(invoiceInfo.invoiceDate).toLocaleDateString("en-GB") : "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Invoice No:</strong></th>
                                            <td>{invoiceInfo.invoiceNo || "N/A"}</td>
                                            <th><strong>PO No:</strong></th>
                                            <td>{invoiceInfo.pono || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Delivery Challan No:</strong></th>
                                            <td>{invoiceInfo.deliveryChallanNumber || "N/A"}</td>
                                            <th><strong>Invoice Value:</strong></th>
                                            <td>{invoiceInfo.invoiceValue?.toFixed(2) || "0.00"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>IGST:</strong></th>
                                            <td>{invoiceInfo.igst?.toFixed(2) || "0.00"}</td>
                                            <th><strong>CGST:</strong></th>
                                            <td>{invoiceInfo.cgst?.toFixed(2) || "0.00"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>SGST:</strong></th>
                                            <td>{invoiceInfo.sgst?.toFixed(2) || "0.00"}</td>
                                            <th><strong>Total Value:</strong></th>
                                            <td>{invoiceInfo.totalValue?.toFixed(2) || "0.00"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Created Date:</strong></th>
                                            <td>{invoiceInfo.createdDate ? new Date(invoiceInfo.createdDate).toLocaleDateString("en-GB") : "N/A"}</td>
                                            <th><strong>Agreement Document:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.agreementFilePath, invoiceInfo.fileNameAgreement, "Agreement Document Preview")}</td>
                                            </tr>
                                            <tr>
                                                <th><strong>Agreement Reference:</strong></th>
                                                <td colSpan={3}>
                                                    {agreementRefs.length > 0 ? (
                                                        agreementRefs.map((a) => (
                                                            <div key={a.agreementId} style={{ marginBottom: "8px" }}>
                                                                {renderDocumentFile(a.filePath, a.fileName, "Agreement Reference Preview")}
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <span style={{ color: "gray" }}>No file uploaded</span>
                                                    )}
                                                </td>
                                            </tr>
                                        <tr>
                                            <th><strong>Email Approval:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.emailApprovalFilePath, "Email Approval", "Email Approval Preview")}</td>
                                            <th><strong>Invoice (PO Upload):</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.invoiceIMAGEFilePath, "Invoice Document", "Invoice Preview")}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>PO Attachment:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.poimageFilePath, "PO Document", "PO Preview")}</td>
                                            <th><strong>PR Attachment:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.primageFilePath, "PR Document", "PR Preview")}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Quotation:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.quotationIMAGEFilePath, "Quotation 1", "Quotation Preview")}</td>
                                            <th><strong>More Quotation:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.quotation2IMAGEFilePath, "Quotation 2", "Quotation Preview")}</td>
                                        </tr>
                                            <tr>
                                                <th><strong>Comparison Quotes:</strong></th>
                                                <td>{renderDocumentFile(invoiceInfo.poDocuments?.comparisonquotesFilePath, "Comparison Quotes", "Comparison Preview")}</td>
                                                <th><strong>Evaluation Form:</strong></th>
                                                <td>{invoiceInfo.evaluationForm ? <a href={invoiceInfo.evaluationForm} target="_blank" rel="noopener noreferrer">View</a> : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th><strong>Other Documents:</strong></th>
                                                <td>{renderDocumentFile(invoiceInfo.poDocuments?.otherDocuementsIMAGEFilePath, "Other Documents", "Other Documents Preview")}</td>
                                                <th><strong>TimeSheet:</strong></th>
                                                <td>
                                                    {invoiceInfo.timeSheetFilePath ? (
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <span style={{ color: "#0a4275", fontWeight: "500" }}>{invoiceInfo.fileNameTimeSheet}</span>
                                                            <div style={{ marginTop: "5px" }}>
                                                                <Button
                                                                    color="primary"
                                                                    size="sm"
                                                                    outline
                                                                    onClick={
                                                                        /\.msg$/i.test(invoiceInfo.fileNameTimeSheet || "")
                                                                            ? viewTimesheetMessage
                                                                            : viewTimesheet
                                                                    }
                                                                >
                                                                    {/\.msg$/i.test(invoiceInfo.fileNameTimeSheet || "")
                                                                        ? "View Message"
                                                                        : /\.(pdf|png|jpe?g|gif|webp)$/i.test(
                                                                            invoiceInfo.fileNameTimeSheet || ""
                                                                        )
                                                                            ? "View"
                                                                            : "Download"}
                                                                </Button>

                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <span style={{ color: "gray" }}>No file uploaded</span>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th><strong>GRN Attachment:</strong></th>
                                                <td>{invoiceInfo.grnAttachment ? <a href={invoiceInfo.grnAttachment} target="_blank" rel="noopener noreferrer">View</a> : "N/A"}</td>
                                                <th><strong>Quotation 3:</strong></th>
                                                <td>{renderDocumentFile(invoiceInfo.poDocuments?.quotation3IMAGEFilePath, "Quotation 3", "Quotation 3 Preview")}</td>
                                            </tr>
                                            
                                        </tbody>
                                </Table>
                                <h5 className="text-primary fw-bold mb-3">The Following goods has been Received.</h5>
                                    <table className="table table-bordered align-middle table-hover invoice-table">
                                        <thead className="table-header11 text-center">
                                            <tr>
                                                <th>Sr. No</th>
                                                <th>Description</th>
                                                <th>Ordered Qty</th>
                                                <th>Supplied Qty</th>
                                                <th>Invoice Value</th>
                                                <th>CGST (%)</th>
                                                <th>SGST (%)</th>
                                                <th>IGST (%)</th>
                                                <th>Total Value</th>
                                                <th>Credit Bill Doc</th>
                                                <th>Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoiceInfo?.grnItems?.length > 0 ? (
                                                invoiceInfo.grnItems.map((item, index) => {
                                                    const creditDocsByRow = groupCreditDocsByRow(creditDocuments);
                                                    const rowDocs = creditDocsByRow[index] || [];
                                                    return (
                                                        <tr key={item.id} className="text-center">
                                                            <td>{index + 1}</td>
                                                            <td className="text-start">{item.description || "-"}</td>
                                                            <td>{item.qty ?? 0}</td>
                                                            <td>{item.rcvQty ?? 0}</td>
                                                            <td>{item.invoiceValue?.toFixed(2) ?? "0.00"}</td>
                                                            <td>{item.cgst ?? 0}</td>
                                                            <td>{item.sgst ?? 0}</td>
                                                            <td>{item.igst ?? 0}</td>
                                                            <td>{item.totalValue?.toFixed(2) ?? "0.00"}</td>
                                                            <td>
                                                                {rowDocs.length === 0 && (
                                                                    <span style={{ color: "gray", fontSize: "12px" }}>No file</span>
                                                                )}
                                                                {rowDocs.map((path, i) => {
                                                                    const fileName = path?.split("/").pop();
                                                                    return (
                                                                        <Button
                                                                            key={i}
                                                                            color="primary"
                                                                            size="sm"
                                                                            outline
                                                                            style={{
                                                                                display: "block",
                                                                                margin: "2px auto",
                                                                                fontSize: "11px",
                                                                                padding: "3px 10px",
                                                                                width: "70%",
                                                                                minWidth: "60px",
                                                                                maxWidth: "90px",
                                                                                borderRadius: "4px",
                                                                                whiteSpace: "nowrap"
                                                                            }}
                                                                            title={fileName}
                                                                            onClick={() => {
                                                                                let cleanPath = path.trim().replace(/\\/g, "/").replace(/^~\/?/, "");
                                                                                const fileUrl = cleanPath.startsWith("http")
                                                                                    ? cleanPath
                                                                                    : `${BASE_URL.replace(/\/$/, "")}/${cleanPath.replace(/^\/+/, "")}`;
                                                                                setPreviewUrl(fileUrl);
                                                                                setPreviewTitle(`Credit Bill Document (Row ${index + 1})`);
                                                                                setShowPreview(true);
                                                                            }}
                                                                        >
                                                                            View
                                                                        </Button>
                                                                    );
                                                                })}
                                                            </td>
                                                            <td>{item.remark || "-"}</td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="11" style={{ textAlign: "center" }}>No GRN Items Available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                            </>
                        )}
                    </div>
                    {/* Footer — only for Approve/Reject tab */}
                    {activeTab === "details" && (
                        <div style={{
                            padding: "12px 24px",
                            borderTop: "1px solid #dee2e6",
                            display: "flex",
                            gap: "10px",
                            justifyContent: "flex-end",
                            flexShrink: 0,
                            backgroundColor: "white"
                        }}>
                            {!isFinalStatus && (
                                <Button color="success" onClick={handleSaveStatus}>Save</Button>
                            )}
                            <Button color="danger" onClick={() => setShowModal(false)}>Close</Button>
                        </div>
                    )}
                        {/* Preview Modal inside fullscreen div (plain div test) */}
                        {showPreview && (
                            <div style={{
                                position: "fixed",
                                top: 0, left: 0,
                                width: "100vw", height: "100vh",
                                backgroundColor: "rgba(0,0,0,0.8)",
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <div style={{ backgroundColor: "white", width: "90%", height: "90%", padding: "10px", display: "flex", flexDirection: "column" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                                        <strong>{previewTitle}</strong>
                                        <button onClick={() => setShowPreview(false)}>Close X</button>
                                    </div>
                                    <p>previewUrl = {previewUrl}</p>
                                    {previewUrl && (
                                        <iframe src={previewUrl} title="Preview" style={{ width: "100%", flex: 1, border: "none" }} />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {/* ======================================================= */}
            {/* REACTSTRAP MODAL — for Vendor Info & History tabs only   */}
            {/* ======================================================= */}
            {showModal && (activeTab === "info" || activeTab === "history") && (
                <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered modalClassName="wide-modal">
                    <ModalHeader toggle={() => setShowModal(false)}>Invoice Details</ModalHeader>
                    <div className="tabs1">
                        <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Vendor Info</span>
                        <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Invoice Approval History</span>
                        <span className={activeTab === "infoInvoice" ? "active-tab" : ""} onClick={() => setActiveTab("infoInvoice")}>Invoice Info</span>
                        <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Approve/Reject</span>
                    </div>
                    <ModalBody>
                        {/* Vendor Info Tab */}
                        {activeTab === "info" && (
                            selectedVendor ? (
                                <VendorInfoTabs
                                    selectedVendor={selectedVendor}
                                    vendorFiles={files}
                                    isEditing={isEditing}
                                    setIsEditing={setIsEditing}
                                    handleInputChange={(e, field) =>
                                        setSelectedVendor({ ...selectedVendor, [field]: e.target.value })
                                    }
                                    subTab={subTab}
                                    setSubTab={setSubTab}
                                    type="invoice"
                                />
                            ) : (
                                <div style={{ textAlign: "center", padding: "40px 20px", color: "#888" }}>
                                    No vendor information available for this invoice.
                                </div>
                            )
                        )}
                        {/* History Tab */}
                        {activeTab === "history" && (
                            <div className="history-container1">
                                <table className="history-table1">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Approval Status</th>
                                            <th>Approver Name</th>
                                            <th>Date</th>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historyData.length > 0 ? (
                                            historyData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.approvalStatus || "N/A"}</td>
                                                    <td>{item.approvalname || "N/A"}</td>
                                                    <td>{item.createdate ? new Date(item.createdate).toLocaleDateString("en-GB") : "N/A"}</td>
                                                    <td>{item.comments || "N/A"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">No history found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </ModalBody>
                    {/* Preview Modal */}
                    <Modal isOpen={showPreview} toggle={() => setShowPreview(false)} size="lg" centered>
                        <ModalHeader toggle={() => setShowPreview(false)}>{previewTitle}</ModalHeader>
                        <ModalBody style={{ padding: 0 }}>
                            {previewUrl ? (
                                <iframe src={previewUrl} title="Preview" style={{ width: "100%", height: "80vh", border: "none" }} />
                            ) : (
                                <p style={{ padding: "20px" }}>No preview available</p>
                            )}
                        </ModalBody>
                    </Modal>
                </Modal>
            )}
        </DashboardLayout>
    );
};
export default ViewAllInvoicesFinanceTeam;
